export const authenticationConstants = {
	LOGGED_IN: 'logged_in',
	
	TOKEN_REVALIDATE: 'token_revalidate',
};
